<template>
    <div class="v2-retailer-order__brand-product">
        <div class="v2-retailer-order__brand-product-logo">
            <img
                :src="product.images.length ? product.images[0].url : null"
                alt=""
                class="v2-retailer-order__brand-product-img ofi"
            />
        </div>
        <div class="v2-retailer-order__brand-product-descr">
            <div class="v2-retailer-order__brand-product-descr-left">
                <div class="v2-retailer-order__brand-product-brand">
                    {{ product.brand.BrandName }}
                    <i
                        v-if="brand.has_restricted_items"
                        :class="
                            brand.approved_access_to_restricted_items
                                ? 'v2-retailer-icon-unlock'
                                : 'v2-retailer-icon-lock'
                        "
                    >
                        <div
                            class="cabinet__catalog-tooltip v2-retailer-cabinet__catalog-tooltip"
                        >
                            <div class="cabinet__catalog-tooltip_text">
                                <template>
                                    {{
                                        brand.approved_access_to_restricted_items
                                            ? 'Вам открыт доступ к скрытым изделиям этого бренда'
                                            : 'У бренда есть скрытые изделия'
                                    }}
                                </template>
                            </div>
                            <div class="cabinet__catalog-tooltip_link">
                                <a
                                    v-if="
                                        brand.access_status === null ||
                                            brand.access_status === 'forbidden'
                                    "
                                    href="javascript:void(0)"
                                    @click.prevent="
                                        $emit('onClickToRequestAccess', brand)
                                    "
                                >
                                    Запросить доступ
                                </a>
                                <span
                                    v-if="brand.access_status === 'new'"
                                    class="color-gray"
                                >
                                    Запрос доступа отправлен
                                </span>
                            </div>
                        </div>
                    </i>
                </div>
                <div class="v2-retailer-order__brand-product-text">
                    {{ product.type.Name }}
                </div>
                <div
                    class="v2-retailer-order__brand-product-text v2-retailer-order__brand-product-text--gray mb-2"
                >
                    Арт. {{ product.Article }}
                </div>
                <div class="v2-retailer-order__brand-product-text">
                    {{ getFormattedNum(product.pivot.Price || 0) }} Р/{{
                        getNameById(
                            priceUnitOptions,
                            'abbr',
                            'id',
                            product.PriceUnit
                        )
                    }}
                </div>
                <div class="v2-retailer-order__brand-product-comment">
                    Комментарий
                    <span>{{ product.pivot.Comment || ' — ' }}</span>
                </div>
            </div>

            <div class="v2-retailer-order__brand-product-descr-right">
                <div class="v2-retailer-order__brand-product-summary">
                    <template v-if="product.Price > 0">
                        {{
                            getFormattedNum(
                                (parseFloat(product.Price) * quantity).toFixed(
                                    2
                                ) || 0
                            )
                        }}
                        Р
                    </template>

                    <template v-else
                        >Цена не указана</template
                    >
                </div>

                <add-to-cart :product="product" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import getNameById from '@/mixins/getNameById'
import getFormattedNum from '@/utils/getFormattedNum'

import AddToCart from '@/components/Cabinet/Retailer/Orders/AddToCart'

export default {
    name: 'OrderProductItem',
    components: { AddToCart },
    mixins: [getNameById],
    props: {
        product: {
            type: Object,
            default: () => {}
        },
        brand: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            changeTimer: null,
            quantity: this.product.pivot.Quantity,
            comment: this.product.pivot.Comment
        }
    },
    computed: {
        ...mapState('other', ['priceUnitOptions']),
        productID() {
            return this.product.ItemID
        }
    },
    methods: {
        ...mapActions('cart', ['deleteFromCart']),
        getFormattedNum,
        changeCartInfo() {
            if (this.changeTimer) {
                clearInterval(this.changeTimer)
            }

            this.changeTimer = setTimeout(() => {
                this.$emit('onChangeItem', {
                    productID: this.productID,
                    quantity: this.quantity,
                    comment: this.comment
                })
            }, 1000)
        },
        removeItem() {
            this.$emit('onRemoveItem', this.productID)
        }
    }
}
</script>
